import { useLocation } from "react-router-dom";
import ArchiveGallery from "./ArchiveGallery";

function AllImages() {
  const { search } = useLocation();
  const category = new URLSearchParams(search).get("category") || "all";

  return (
    <ArchiveGallery
      category={category}
      collectionLabel="Collections"
      emptyTitle="No artwork found in the archive."
    />
  );
}

export default AllImages;
